import {FC, ReactNode} from 'react';
import {Box} from '@mui/material';

import {COLOR__PRIMARY} from '@/theme/colors';

interface Props {
  changed: boolean;
  flex?: number | string;
  children: ReactNode;
}

// Draws a blue frame around a field that differs from what was originally
// loaded, so unsaved changes are visible at a glance.
export const FieldChangeHighlight: FC<Props> = ({changed, flex, children}) => (
  <Box
    flex={flex}
    borderRadius={1}
    sx={{
      '& > *': {
        borderRadius: 1,
        outline: changed ? `2px solid ${COLOR__PRIMARY}` : 'none',
        outlineOffset: 2,
      },
    }}
  >
    {children}
  </Box>
);
